import React from "react";
import { Typography } from "@vp/swan";
import { useTranslation } from "react-i18next";

export const SetupFee: React.FC<{}> = () => {
  const { t } = useTranslation();
  // G&T currently doesn't support products with setup fee
  const setupFeeText = t("no-setup-fee");

  return <Typography fontSkin="body-small">{setupFeeText}</Typography>;
};
